import { useTranslation } from 'react-i18next'
import { Form, Formik } from 'formik'
import * as yup from 'yup'

import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import Grid from '@mui/material/Grid'
import LoadingButton from '@mui/lab/LoadingButton'
import Stack from '@mui/material/Stack'

import PhoneNumberField from '@/components/formik/fields/PhoneNumberField'
import TextField from '@/components/formik/fields/TextField'

export type AddDoctorFormValues = {
  _id?: string
  name?: string
  surname?: string
  cps?: string
  email?: string
  phone?: string
  cp?: string
}

export type AddDoctorFormDialogProps = {
  initialValues: AddDoctorFormValues
  isSubmitting?: boolean
  onSubmit?: (values: AddDoctorFormValues) => void
  onClose?: () => void
  open: boolean
}

const addDoctorFormValidationSchema = yup.object().shape({
  name: yup.string().required(),
  surname: yup.string().required(),
  cps: yup.string().optional().min(11).max(11),
  email: yup.string().email(),
  cp: yup.string().optional(),
})

export function AddDoctorFormDialog(props: AddDoctorFormDialogProps) {
  const { initialValues, isSubmitting = false, onClose, onSubmit, open } = props
  const { t } = useTranslation()

  const handleSubmit = (values: AddDoctorFormValues) => {
    onSubmit?.(values)
  }

  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle>{t('component.group.addDoctorFormDialog.title')}</DialogTitle>
      <DialogContent>
        <Formik enableReinitialize initialValues={initialValues} onSubmit={handleSubmit} validationSchema={addDoctorFormValidationSchema}>
          {(formikProps) => (
            <Form onSubmit={formikProps.handleSubmit}>
              <Grid container rowSpacing={3} columnSpacing={3}>
                <Grid item xs={6}>
                  <TextField fullWidth label={t('field.lastName.label')} name="surname" />
                </Grid>
                <Grid item xs={6}>
                  <TextField fullWidth label={t('field.firstName.label')} name="name" />
                </Grid>
                <Grid item xs={6}>
                  <TextField fullWidth label={t('field.cps.label')} name="cps" />
                </Grid>
                <Grid item xs={6}>
                  <TextField fullWidth label={t('field.speciality.label')} name="speciality" />
                </Grid>
                <Grid item xs={12}>
                  <TextField fullWidth label={t('field.postalCode.label')} name="cp" />
                </Grid>
                <Grid item xs={12}>
                  <TextField fullWidth label={t('field.email.label')} name="email" />
                </Grid>
                <Grid item xs={12}>
                  <PhoneNumberField label={t('field.phone.label')} name="phone" />
                </Grid>
                <Grid item xs={12}>
                  <Stack direction="row" justifyContent="end" spacing={2}>
                    <Button variant="neutral" onClick={onClose}>
                      {t('common:button.cancel.label')}
                    </Button>
                    <LoadingButton disabled={!formikProps.isValid} disableElevation loading={isSubmitting} type="submit" variant="contained">
                      {t('common:button.add.label')}
                    </LoadingButton>
                  </Stack>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  )
}

export default AddDoctorFormDialog
